import Button from "../../Common/Components/ButtonComponent/Button";
import DescriptionHtmlCode from "../../Common/Components/HtmlCode/DescriptionHtmlCode";
import ShowOnlyText from "../../Common/Components/HtmlCode/ShowOnlyText";

const ReusableButtonComponent = ({
  index,
  indexLink,
  setIndexLink,
  buttonData,
  handleInputChange,
  errors,
  removeButton,
  isEditable,
  isLoading,
  toggleLink,
  setIndex,
  setDynamicLink,
  getImageUrl,
  handleRemoveIcon,
  toggle,
  setEventData,
}) => {
  return (
    <div className="bg-white border border-black-600 rounded-[5px] px-4 py-4">
      <label className="inline-block mb-2 text-base font-medium">
        Header Text
      </label>
      <input
        type="text"
        disabled={!isEditable}
        value={buttonData?.header_text}
        onChange={(e) =>
          handleInputChange(index, "header_text", e.target.value)
        }
        className="mb-2 form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
        placeholder="Enter header text"
      />
      {errors.buttons[index]?.header_text && (
        <p className="text-sm text-red-500">
          {errors.buttons[index].header_text}
        </p>
      )}

      <label className="inline-block mb-2 text-base font-medium">
        Description
      </label>
      {!isEditable ? (
        <ShowOnlyText content={buttonData.description} setContent={""} />
      ) : null}
      {isEditable ? (
        <DescriptionHtmlCode
          content={buttonData.description}
          setContent={(e) => handleInputChange(index, "description", e)}
        />
      ) : null}

      {errors.buttons[index]?.description && (
        <p className="text-sm text-red-500">
          {errors.buttons[index].description}
        </p>
      )}

      <div className="flex mt-2">
        <input
          type="text"
          disabled={true}
          value={buttonData?.link}
          onChange={(e) => handleInputChange(index, "link", e.target.value)}
          className="mb-2 form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
          placeholder="Enter Link"
        />
        {isEditable && (
          <div
            onClick={() => {
              toggleLink();
              setIndexLink(index + 1);
              setDynamicLink("");
            }}
            className="mb-2 ml-2 text-white cursor-pointer btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
          >
            Add Link
          </div>
        )}
      </div>
      {errors.buttons[index]?.link && (
        <p className="text-sm text-red-500">{errors.buttons[index].link}</p>
      )}

      <div className="flex my-4">
        {buttonData?.image_url ? (
          <div className="flex items-center">
            <div className="relative w-40 h-40">
              <img
                data-dz-thumbnail
                className="border rounded border-gray"
                style={{ objectFit: "contain", width: "100%", height: "100%" }}
                src={getImageUrl(buttonData?.image_url)}
                alt="img"
              />
              {isEditable && (
                <span
                  style={{
                    position: "absolute",
                    top: "0px",
                    right: "6px",
                    fontSize: "22px",
                    cursor: "pointer",
                  }}
                  onClick={() => handleRemoveIcon(index)}
                >
                  ×
                </span>
              )}
            </div>
            {isEditable && (
              <button
                onClick={() => {
                  toggle();
                  setEventData(undefined);
                  setIndex(index);
                }}
                className="ml-3 text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
              >
                Change
              </button>
            )}
          </div>
        ) : (
          isEditable && (
            <button
              onClick={() => {
                toggle();
                setEventData(undefined);
                setIndex(index);
              }}
              className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
            >
              Add Image URL
            </button>
          )
        )}
      </div>
      {errors.buttons[index]?.image_url && (
        <p className="text-sm text-red-500">
          {errors.buttons[index].image_url}
        </p>
      )}

      <label className="inline-block mb-2 text-base font-medium">
        Image Alt Text
      </label>
      <input
        type="text"
        disabled={!isEditable}
        value={buttonData?.segment_image_alt_text}
        onChange={(e) =>
          handleInputChange(index, "segment_image_alt_text", e.target.value)
        }
        className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
        placeholder="Enter segment image alt text"
      />

      <div className="flex justify-end mt-2">
        <Button
          btnText="Remove"
          onClick={() => removeButton(index)}
          disabled={!isEditable}
          isLoading={isLoading}
          className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
        />
      </div>
    </div>
  );
};

export default ReusableButtonComponent;
